export default __webpack_public_path__ + "static/media/AAFSCfeatures.5809736a.jpg";